import { PlantLayoutEditorThemeModeConfig } from './types';

const dark: PlantLayoutEditorThemeModeConfig = {
  plantLayoutEditor: {},
};

export default dark;
